<template functional>
  <component :is="injections.components.VList" two-line color="transparent">
    <component
      :is="injections.components.VListItem"
      v-for="drsCustomer in props.items"
      :key="drsCustomer.id"
    >
      <component :is="injections.components.VListItemContent">
        <component
          :is="injections.components.VListItemTitle"
          v-html="
            `${drsCustomer.fullName} <span class='grey--text'>(${drsCustomer.drsBuysCount} buys)</span>`
          "
        />
        <component
          :is="injections.components.VListItemSubtitle"
          v-text="`Code: ${drsCustomer.code}, Store: ${drsCustomer.store.name}`"
        />
      </component>
    </component>
  </component>
</template>

<script>
import {
  VList,
  VListItem,
  VListItemContent,
  VListItemSubtitle,
  VListItemTitle,
} from "vuetify/lib";
export default {
  inject: {
    components: {
      default: () => ({
        VList,
        VListItem,
        VListItemContent,
        VListItemSubtitle,
        VListItemTitle,
      }),
    },
  },
  name: "CustomerDetailDialogDrsRecords",
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
